import { render, staticRenderFns } from "./WorkTaskVerifyMeasureItem.vue?vue&type=template&id=dc3b710e"
import script from "./WorkTaskVerifyMeasureItem.vue?vue&type=script&lang=ts"
export * from "./WorkTaskVerifyMeasureItem.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports